// img
import eventImg1 from "../assets/png/invite-frame.png";
import eventImg2 from "../assets/png/segregate-frame.png";
import eventImg3 from "../assets/png/share-frame.png";
import galleryImg from "../assets/png/ai-gallery.png";
// import partnerImg1 from "../assets/svg/partners/jiocloud.svg";
import partnerImg2 from "../assets/svg/partners/dropbox.svg";
// import partnerImg3 from "../assets/svg/partners/googledrive.svg";
import albumImg from "../assets/png/digital-album.png";
import tailArrowIcon from "../assets/svg/arrows/arrow-right-line.svg";
import photographerImg from "../assets/png/photographer.png";
import phoneMockup1 from "../assets/png/iphone-mockups/mockup_1.png";
// import phoneMockup2 from "../assets/png/iphone-mockups/mockup_2_changed.png";
import jiohomeMockup from "../assets/png/iphone-mockups/jiohome_mockup.png";
import phoneMockup3 from "../assets/png/iphone-mockups/mockup_3.png";
import phoneMockup4 from "../assets/png/iphone-mockups/mockup_4.png";
import phoneMockup5 from "../assets/png/iphone-mockups/mockup_5.png";

// Css
import classes from "./Landing.module.css";

// Mui
import { Box, Stack, Typography } from "@mui/material";

// Local
import PrimaryButton from "../components/UI/Buttons/PrimaryButton";
import Badge from "../components/UI/Badges/Badge";
import SecondaryButton from "../components/UI/Buttons/SecondaryButton";
import CustomCard from "../components/UI/Cards/CustomCard";
import PriceCard from "../components/UI/Cards/PriceCard";
import Footer from "../components/Layout/Footer/Footer";
import { Doughnut } from "react-chartjs-2";
import {
  Button,
  Carousel,
  CarouselSlide,
  Container,
  ContentLayout,
  Heading,
  Icon,
  Text,
} from "@jds/core";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const Header = (props) => (
  <Typography variant="h1" mb={3} fontSize="64px" {...props}>
    {props.children}
  </Typography>
);

const Subtitle1 = (props) => (
  <Typography
    variant="subtitle1"
    maxWidth="582px"
    fontSize="24px"
    lineHeight="32px"
    {...props}
  >
    {props.children}
  </Typography>
);

const howItWorks_content = [
  {
    img: phoneMockup1,
    title: "Create and customize your event",
    subtitle:
      "Effortlessly add event details and invite guests with just a few clicks.",
  },
  {
    img: jiohomeMockup,
    title: "Capture basic details for a personalised experience",
    subtitle:
      "Ask guests to upload selfies and details, ensuring a personalized and engaging photo-sharing experience",
  },
  {
    img: phoneMockup3,
    title: "Effortless photo segregation",
    subtitle:
      "Upload event photos easily and use advanced facial recognition to automatically sort guests' faces based on their selfies.",
  },
  {
    img: phoneMockup4,
    title: "Personalized access for guests",
    subtitle:
      "Enhance guest experiences by offering tailored access levels, such as Full Access and Face Access, as well as permissions to Upload or Download media.",
  },
  {
    img: phoneMockup5,
    title: "Easy photo viewing for guests",
    subtitle:
      "Guests can conveniently view and cherish event memories through a user-friendly interface.",
  },
];

export default function Landing() {
  const navigate = useNavigate();
  const bearerToken = localStorage.getItem("authToken");
  const refreshToken = localStorage.getItem("refreshToken");
  useEffect(() => {
    if (bearerToken && refreshToken) {
      navigate("/home");
    }
  }, []);
  // Event dashboard chart
  const data = {
    labels: ["62% attendees", "13% Non-attendees", "Tentative"],
    datasets: [
      {
        label: "# of Votes",
        data: [0.62, 0.13, 0.23],
        backgroundColor: ["#3535f3ff", "#FFD2AD", "#FBE5F4"],
        borderColor: [" #3535f3ff", "#FFD2AD", "#FBE5F4"],
        borderWidth: 1,
        borderRadius: 4,
        spacing: 8,
      },
    ],
  };
  const options = {
    plugins: {
      tooltip: {
        titleFont: {
          size: 20,
        },
        bodyFont: {
          size: 20,
        },
      },
      legend: {
        display: false,
        responsive: true,
        position: "left",
        borderRadius: 6,
        labels: {
          pointStyleWidth: 36,
          usePointStyle: true,
          pointStyle: "rectRounded",
          font: {
            size: 16,
          },
        },
        align: "center",
      },
    },
  };
  return (
    <>
      {/* ========================== BANNER SECTION ========================== */}
      <section className={classes.banner}>
        <div className="inner-container">
          <div className={classes["banner__content"]}>
            <Header className={classes["banner__heading"]}>
              Seamless sharing, endless memories!
            </Header>
            <Typography
              variant="subtitle1"
              maxWidth="392px"
              color="var(--text-medium)"
              mb={4}
            >
              Send invites and share event pictures securely and conveniently
              using AI.
            </Typography>
            {/* <PrimaryButton>Get now</PrimaryButton> */}
          </div>
        </div>
      </section>
      {/* ========================== EVENTS SECTION ========================== */}
      <section className={classes["section--1"]}>
        <Box textAlign="center" mb="80px">
          <Typography variant="h1" mb={3}>
            Your events, our canvas
          </Typography>
          <Typography variant="subtitle1" maxWidth="730px" mx="auto">
            JioPhotos makes it easy to create, invite, and share your media! No
            more photo-chasing after events! You can access all your event media
            in one place.
          </Typography>
        </Box>
        <div className="inner-container">
          <Stack
            direction="row"
            flexWrap={"wrap"}
            gap={2}
            justifyContent={"center"}
          >
            <div className={classes["event-img__box"]}>
              <div className={classes["event-img__overlay"]}></div>
              <img src={eventImg1} alt="" />
              <div className={classes["event-img__content"]}>
                <Text
                  text="Instant Invites"
                  appearance="heading-m"
                  color="white"
                />
                <Text
                  text="Receive instant acceptance for your event invitations."
                  appearance="body-m"
                  color="primary_grey_60"
                />
              </div>
            </div>
            <div className={classes["event-img__box"]}>
              <div className={classes["event-img__overlay"]}></div>
              <img src={eventImg2} alt="" />
              <div className={classes["event-img__content"]}>
                <Text
                  text="Intelligent Segregation"
                  appearance="heading-m"
                  color="white"
                />
                <Text
                  text="Utilize Face Recognition technology 
                  to automatically organize 
                  all event photos."
                  appearance="body-m"
                  color="primary_grey_60"
                />
              </div>
            </div>
            <div className={classes["event-img__box"]}>
              <div className={classes["event-img__overlay"]}></div>
              <img src={eventImg3} alt="" />
              <div className={classes["event-img__content"]}>
                <Text
                  text="Easy Sharing"
                  appearance="heading-m"
                  color="white"
                />
                <Text
                  text="Share specific photos with event attendees effortlessly."
                  appearance="body-m"
                  color="primary_grey_60"
                />
              </div>
            </div>
          </Stack>
        </div>
      </section>
      {/* ========================== AI Gallery Section ========================== */}
      <section className={classes["section--2"]}>
        <div className="inner-container">
          <Stack
            direction="row"
            flexWrap="wrap"
            justifyContent="space-between"
            sx={{
              "@media screen and (max-width: 1120px)": {
                justifyContent: "center",
              },
            }}
          >
            <div className={classes.content}>
              <Box mb={4} maxWidth="582px">
                <Typography variant="h1" fontSize="64px" mb={3}>
                  JioPhotos AI Gallery
                </Typography>
                <Subtitle1>
                  Find your media with JioPhotos' intelligent facial sorting.
                  Share precious moments with friends and family, and enjoy
                  accessing your media anytime, anywhere, on connected devices.
                </Subtitle1>
              </Box>
              {/* <PrimaryButton>Get now</PrimaryButton> */}
            </div>
            <div className={classes["img-box"]}>
              <img src={galleryImg} alt="gallery" />
            </div>
          </Stack>
        </div>
      </section>
      {/* ========================== partners section ========================== */}
      {/* <section className={classes["section--3"]}>
        <div className="inner-container">
          <Box textAlign="center">
            <Badge
              label="Storage Partners"
              bgColor="#E5F7EE"
              color="var(--text-color)"
              sx={{ width: "184px", mb: 5, justifyContent: "center" }}
                icon={<img src={heartIcon} alt="heart symbol" />}
            />
          </Box>
          <Container fullWidth horizontalAlign="center">
            <Container
              fullWidth
              layout="3-col-even"
              direction="row"
              horizontalAlign="center"
              verticalAlign="center"
              gap={50}
            >
              <img src={partnerImg1} alt="jio cloud logo" />
              <img src={partnerImg2} alt="dropbox logo" />
              <img src={partnerImg3} alt="google drive logo" />
            </Container>
          </Container>
        </div>
      </section> */}
      {/* ========================== How it works section ========================== */}
      <section className={classes["section--4"]} id="section-4">
        <div className="inner-container">
          <Box textAlign="center" mb="60px">
            <Typography variant="h2" mb={4} color="#fff">
              How it works
            </Typography>
            <Box
              sx={{
                "@media screen and (max-width: 1024px)": {
                  padding: "0 32px",
                },
              }}
            >
              <Carousel autoPlay showArrows hideNextSlide>
                {howItWorks_content.map((item, i) => {
                  return (
                    <CarouselSlide key={i}>
                      <Stack
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        gap="100px"
                        pb={4}
                        flexWrap={"wrap-reverse"}
                      >
                        <div className="img-container">
                          <img src={item.img} alt="" />
                        </div>
                        <div className={classes.content}>
                          <Badge
                            bgColor="var(--color-sparkle-40)"
                            color="var(--color-primary-80)"
                            label={`Step ${i + 1}`}
                            textProps={{
                              variant: "subtitle2",
                              fontFamily: "var(--font-semibold)",
                            }}
                          />
                          <Header mt={2} maxWidth={"715px"}>
                            {item.title}
                          </Header>
                          <Typography
                            variant="h3"
                            fontFamily="var(--font-medium)"
                            color="var(--text-medium)"
                            maxWidth={"615px"}
                            mb={4}
                          >
                            {item.subtitle}
                          </Typography>
                          {/* <PrimaryButton>Get now</PrimaryButton> */}
                        </div>
                      </Stack>
                    </CarouselSlide>
                  );
                })}
              </Carousel>
            </Box>
          </Box>
        </div>
      </section>
      {/* ========================== partners section ========================== */}
      <section className={classes["section--5"]}>
        <div className="inner-container">
          <Stack direction="column" gap="80px">
            <Stack
              direction="row"
              justifyContent="space-between"
              flexWrap="wrap"
              sx={{
                "@media screen and (max-width: 1120px)": {
                  justifyContent: "center",
                  "& > div": {
                    textAlign: "center",
                    marginBottom: "32px",
                  },
                },
              }}
            >
              <div>
                <Header>Event Dashboard</Header>
                <Subtitle1>
                  Gain insights into event attendance by identifying attendees,
                  non-attendees, and tentative attendees.
                </Subtitle1>
              </div>
              <CustomCard
                shadowpercent=".24"
                radius="36px"
                sx={{ width: "484px", p: 4 }}
              >
                <Stack direction="row" justifyContent="space-between">
                  <div className={classes["event-data__list"]}>
                    <div className={classes["event-data__item"]}>
                      <div className={classes["legend-box"]}></div>
                      <Typography
                        variant="subtitle1"
                        fontFamily={"var(--font-semibold)"}
                        component="span"
                      >
                        62%
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        fontFamily={"var(--font-semibold)"}
                        component="span"
                        sx={{ color: "#bbbbbb" }}
                      >
                        Attendees
                      </Typography>
                    </div>
                    <div className={classes["event-data__item"]}>
                      <div className={classes["legend-box"]}></div>
                      <Typography
                        variant="subtitle1"
                        fontFamily={"var(--font-semibold)"}
                        component="span"
                      >
                        13%
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        fontFamily={"var(--font-semibold)"}
                        component="span"
                        sx={{ color: "#bbbbbb" }}
                      >
                        Non-Attendees
                      </Typography>
                    </div>
                    <div className={classes["event-data__item"]}>
                      <div className={classes["legend-box"]}></div>
                      <Typography
                        variant="subtitle1"
                        fontFamily={"var(--font-semibold)"}
                        component="span"
                      >
                        23%
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        fontFamily={"var(--font-semibold)"}
                        component="span"
                        sx={{ color: "#bbbbbb" }}
                      >
                        Tentative
                      </Typography>
                    </div>
                  </div>
                  <Box width="192px">
                    <Doughnut
                      data={data}
                      options={options}
                      //   {...props}
                    />
                  </Box>
                </Stack>
              </CustomCard>
            </Stack>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              flexWrap="wrap"
              className={classes["digital-album__container"]}
              sx={{
                "@media screen and (max-width: 1120px)": {
                  justifyContent: "center",
                  "& > div": {
                    textAlign: "center",
                    marginTop: "32px",
                  },
                },
              }}
            >
              <img
                src={albumImg}
                alt="three celebration photos grouped"
                className=""
              />
              <Box>
                <Header>Your Digital Album</Header>
                <Subtitle1>
                  Break free from old photo-sharing ways. Customize your photos
                  by incorporating stylish frames and share with your guests.
                </Subtitle1>
              </Box>
            </Stack>
          </Stack>
          <Box
            textAlign="center"
            sx={{ maxWidth: "206px", margin: "0 auto", mt: "80px" }}
          >
            {/* <SecondaryButton
              size="large"
              onClick={() => navigate("/auth/signin")}
            >
              Sign in now
            </SecondaryButton> */}
            <Button
              fullWidth
              label="Sign in now"
              size="large"
              kind="secondary"
              onClick={() => {
                // navigate("/auth/signin");
                window.location.href = process.env.REACT_APP_JIOCLOUD_HOME_URL;
              }}
            />
          </Box>
        </div>
      </section>
      {/* ========================== Pricing section ========================== */}
      <section className={classes["section--6"]}>
        <div className="inner-container">
          <Box textAlign="center" mb="60px">
            <Typography variant="h2" mb={2}>
              Pricing Plan
            </Typography>
            <Typography variant="subtitle1">
              {/* Every plan includes 30day free trial */}
              More plans are coming soon!
            </Typography>
          </Box>
          <Stack
            direction="row"
            justifyContent="center"
            gap={2}
            flexWrap={"wrap"}
          >
            <CustomCard
              className={classes["price-card__banner"]}
              radius="20px"
              sx={{ boxShadow: "none", width: "384px" }}
            >
              <Typography variant="h2" fontFamily="var(--font-medium)" mb={1}>
                Save More
              </Typography>
              <Typography variant="h2" fontFamily="var(--font-semibold)" mb={3}>
                With Goodplans.
              </Typography>
              <Typography
                variant="subtitle1"
                color="#fff"
                fontFamily="var(--font-medium)"
                letterSpacing={"-0.5px"}
                mb={6}
              >
                Capture, organise, share: Choose your plan today!
              </Typography>
              <Box width={40}>
                {/* <img src={tailArrowIcon} alt="right tail arrow icon" /> */}
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                  <g clip-path="url(#clip0_528_6724)">
                    <path
                      d="M26.9537 18.3338L18.0137 9.39378L20.3703 7.03711L33.3337 20.0004L20.3703 32.9638L18.0137 30.6071L26.9537 21.6671H6.66699V18.3338H26.9537Z"
                      fill="#fff"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_528_6724">
                      <rect width="40" height="40" fill="#fff" />
                    </clipPath>
                  </defs>
                </svg>
              </Box>
              <Box textAlign="right">
                <img
                  className={classes["price-card__banner-img"]}
                  src={photographerImg}
                  alt="women photographer"
                />
              </Box>
            </CustomCard>
            <Stack direction="row">
              <PriceCard />
            </Stack>
          </Stack>
        </div>
      </section>
      {/* ========================== Footer section ========================== */}
      <Footer />
    </>
  );
}
